import { h, Component, } from 'preact';
import WidgetComponent from 'components/WidgetComponent'
import {Form, Button, I18n, FormEntry, Col, Row, Divider, Container, Toggle } from 'components/elements' 
import {connect} from 'react-redux'
import {AccountActions} from 'actions'
import style from './style.less'
import countries from 'lib/countries'
import _ from 'lodash'

const Fragment = h.Fragment = 'x-fragment'

let mapInputType = {
    Dropdown: 'text',
    String: 'text',
    Integer: 'number',
    Float: 'number'
}

@Form
@connect((state)=> state)
export default class ContactInformation extends WidgetComponent {
    constructor(){
        super()
        this.state = {
            editing: false,
            grantError: false,
            passwordError: false,
            emailError: false,
            phoneError: false,
            accessToggled: false,
            customBooleans: {}
        }
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleToggleEdit = this.handleToggleEdit.bind(this)
        this.handleError = this.handleError.bind(this)
        this.handleEmailChange = this.handleEmailChange.bind(this)
        this.handleMobileChange = this.handleMobileChange.bind(this)
        this.handleToggleAccess = this.handleToggleAccess.bind(this)
        this.handleStateSearch = this.handleStateSearch.bind(this)
        this.handlePassword = this.handlePassword.bind(this)
        this.handlePasswordConfirmation = this.handlePasswordConfirmation.bind(this)
    }

    componentWillMount(){
        if(!this.props.finishedClient){
            let requiredFields = ['firstName', 'lastName', 'address', 'city', 'state', 'zip', 'mobilePhone', 'email']
            let customBooleans = {}
            for(let customField of this.customFields){
                if(customField.type == 'Boolean'){
                    customBooleans[customField.key] = this.account[customField.key] || false
                }
                if(customField.required){
                    requiredFields.push(customField.key)
                }
            }
    
            this.setState({
                customBooleans
            })
            const exist = _.every(requiredFields, (a) =>{
                return (this.session.account || {})[a] 
            })
            let orgHasAccess = false
            for(let organization of (this.props.session.organizations || [])){
                if(organization.id == this.props.config.organizationID){
                    orgHasAccess = true
                }
            }
            if (!this.session.accessToken || !exist || !orgHasAccess) {
                this.setState({
                    editing: true
                })
            } else {
                super.componentDidSubmit()
                this.props.onSubmit && this.props.onSubmit()
            }
        }
    }

    grantAccess (e) {
        return AccountActions.grant({organizationID: this.props.organization.id})
    };

    get account() {
        let data = {
            ...(this.session.account || {})
        }
        return data;
    }

    get session(){
        return (this.props.session || {})
    }

    get organizationAccess() {
        if(!(this.session.organizations || []).some((organization)=>{ return organization.id == this.props.organization.id})){
            return false
        }
        return true
    }

    get organization(){
        return this.props.organization || {country: 'US'}
    }
    
    get states(){
        return countries.statesOrProvinces(this.organization.country)
        .map((state)=>({name: state.name, value: state.code}))
    }

    get stateValue(){
        return this.state.stateSearch || this.account.state || ''
    }
    
    get customFields(){
        return Object.values(this.props.customFields || {}).filter((customField)=>{
            return customField.model == 'Account'
        }).sort((a,b)=>{
            if(a.type == 'Boolean') return 1
            if(b.type == 'Boolean') return -1
            return 0
        })
    }

    handleToggleCustomField(customField, e){
        this.setState({
            customBooleans: {
                ...this.state.customBooleans,
                [customField.key]: !this.state.customBooleans[customField.key]
            }
        })
    }

    handleStateSearch(value){
        this.setState({
            stateSearch: value
        })
    }

    handleToggleAccess(){
        this.setState({
            accessToggled: !this.state.accessToggled,
            toggleError: false
        })
    }

    handleGrantAccess (e) {
        e.preventDefault()
        
        return AccountActions.grant({
            organizationID: this.props.organization.id
        })
    };

    handleSubmit(values){
        if(this.componentIsLoading()){
            return
        }
        Object.keys(values).forEach((key)=>{
            if(_.isNil(values[key])){
                delete values[key]
            }
        })

        let data = {
            ...this.props.session.account,
            ...values,
            ...this.state.customBooleans
        }

        AccountActions.set({...data})

        this.setState({
            passwordError: false,
            grantError: false,
        })
        this.componentWillSubmit().then((r)=>{
            if(!this.organizationAccess && !this.state.accessToggled){
                this.setState({
                    grantError: 'You must grant access to continue'
                })
                this.componentFailedToSubmit()
            } else if(this.account.id){
                this.grantAccess().then(()=>{
                    return AccountActions.update({...data})
                }).then((response)=>{
                    if(!this.organizationAccess){
                        return this.grantAccess()
                    }
                })
                .then((res)=>{
                    this.setState({
                        editing: false
                    })
                    super.componentDidSubmit()
                    this.props.onSubmit && this.props.onSubmit()
                })
                .catch((e)=>{
                    this.componentFailedToSubmit(e)
                    this.handleError(e)
                })
            } else {
                if(values.password === values.passwordConfirmation){
                    AccountActions.create({...data}).then((response)=>{
                        this.setState({
                            editing: false
                        })
                        super.componentDidSubmit()
                        this.props.onSubmit && this.props.onSubmit()
                    })
                    .catch((e)=>{
                        this.componentFailedToSubmit(e)
                        this.handleError(e)
                    })
                } else if (values.password != values.passwordConfirmation){
                    this.setState({
                        passwordError: 'Passwords do not match'
                    })
                    this.componentFailedToSubmit()
                }
            }
        })
        
    }

    handleToggleEdit(e){
        if(!e || e.target.id == "contact-edit"){
            this.setState({
                editing: !this.state.editing
            })
        }
    }

    handleError(e){
        if(e.response){
            e = (e.response.data || {}).errors || ''
            if(e.includes('email')){
                this.setState({
                    emailError: true
                })
            }
            if(e.includes('mobilePhone')){
                this.setState({
                    phoneError: true
                })
            }
            if(Array.isArray(e)){
                let errorMessage = []
    
                if(e.includes("min")){
                    errorMessage.push("Must be at least 8 characters")
                }
                if(e.includes("uppercase")){
                    errorMessage.push("Must have at least 1 upper case character")
                }
                if(e.includes("digits")){
                    errorMessage.push("Must have at least 1 digit")
                }
                if(e.includes("specialCharacter")){
                    errorMessage.push("Must have at least 1 special character")
                }
                this.setState({
                    passwordError: `Invalid Password: ${errorMessage.join(", ")}`
                })
            }
            if(!e){
                this.setState({
                    passwordError: `An unknown error has occured`
                })
            }
        }
    }

    handleMobileChange(){
        if(this.state.phoneError){
            this.setState({
                phoneError: false
            })
        }
    }

    handleEmailChange(){
        if(this.state.emailError){
            this.setState({
                emailError: false
            })
        }
    }

    handlePassword(e){
        const value = e.target.value
        this.setState({
          passwordValue: value,
          passwordConfirmationMatches: value == this.state.passwordConfirmationValue,
          hasNumber: value.match(/(?=.*\d)/),
          hasLowerCase: value.match(/(?=.*[a-z])/),
          hasUpperCase: value.match(/(?=.*[A-Z])/),
          hasEightCharacters:  value.match(/(?=.{8,8})/)
        })
      }

      handlePasswordConfirmation(e){
        const value = e.target.value
        this.setState({
          passwordConfirmationValue: value,
          passwordConfirmationMatches: value == this.state.passwordValue
        })
      }

    render() {
        const open = {
            class: "fa fa-dot-circle",
            style: {
                color:'rgb(160, 160, 160)'
            }
        }
        
        const checked = {
            class: 'fa fa-check-circle',
            style: {
                color:'rgb(82, 196, 26)'
            }
        } 
        const {Form, InputDark, SelectDark} = this.props
        return (
            <Container key={this.props.containerKey}>
                {this.session.accessToken?
                    <div class={style.editText} id="contact-edit" onClick={this.handleToggleEdit}>
                        {this.state.editing ?
                            <I18n>cancel</I18n>
                            : 
                            <I18n>edit</I18n>
                        }
                    </div>
                :
                    ''
                }

                <div>
                    <strong>
                        {this.account.firstName?
                            `${this.account.firstName} ${this.account.lastName}`
                        :
                            "Fill out your Personal Information"
                        }
                    </strong>
                    <br />
                    <br />
                </div>
                <br />
                <Form id={this.account.id || 'newAccount'} onSubmit={this.handleSubmit} >
                    {!this.state.editing ?
                        <div>
                            <I18n>contact</I18n>
                            <br />
                            <Row>
                                {this.account.email &&
                                    <Col span={{sm: 24,md: 12}}>
                                        <label><I18n>email</I18n></label>
                                        {this.account.email}
                                    </Col>
                                }
                                {this.account.mobilePhone && 
                                    <Col span={{sm: 24,md: 12}}>
                                        <label>{I18n.t("mobilePhone")}</label>
                                        {this.account.mobilePhone}
                                    </Col>
                                }
                            </Row>
                            <br />
                            <br />
                            <label>
                                <I18n>address</I18n>
                            </label>
                            <br />
                            {this.account.address} {this.account.unit}
                            <br />
                            {this.account.city}, {this.account.state} {this.account.zip}
                        </div>
                    :
                        <Fragment>
                            <Row>
                                <Col span={{sm: 3}}>
                                    <FormEntry>
                                        <InputDark name='title' id='title' question={I18n.t('title')} type='text' initialValue={this.account.title} />
                                    </FormEntry>
                                </Col>
                                <Col span={{sm: 9}}>
                                    <FormEntry>
                                        <InputDark required={true} name='firstName' id='firstName' question={I18n.t('firstName')} type='text' initialValue={this.account.firstName}  />
                                    </FormEntry>
                                </Col>
                                <Col span={{sm: 3}}>
                                    <FormEntry>
                                        <InputDark name='middleInitial' id='middleInitial' question={I18n.t('middleInitial')} type='text' initialValue={this.account.middleInitial}  />
                                    </FormEntry>
                                </Col>
                                <Col span={{sm: 9}}>
                                    <FormEntry>
                                        <InputDark required={true} name='lastName' id='lastName' question={I18n.t('lastName')} type='text' initialValue={this.account.lastName} />
                                    </FormEntry>
                                </Col>
                            </Row>
                            <br />
                            <br />
                            <I18n>contact</I18n>
                            <br />
                            <Row>
                                <Col span={{sm: 12}}>
                                    <FormEntry>
                                        <InputDark required={true} name='email' id='email' question={I18n.t('email')} type='email' initialValue={this.account.email} onChange={this.handleEmailChange}/>
                                    </FormEntry>
                                    {this.state.emailError &&
                                        <div class={style.errorMessage}>This email has already been used</div>	
                                    }
                                </Col>
                                <Col span={{ sm: 12 }}>
                                    <FormEntry>
                                        <InputDark required={true} name='mobilePhone' id='mobilePhone' question={I18n.t("mobilePhone")} type='tel' pattern="[0-9]{3}[0-9]{3}[0-9]{4}" initialValue={this.account.mobilePhone} onChange={this.handleMobileChange} />
                                    </FormEntry>
                                    {<div style={{ paddingTop: '10px', paddingLeft: '5px', height: '0px' }}>(e.g. 4435579282)</div>}
                                    
                                    {this.state.phoneError &&
                                        <div class={style.errorMessage}>This phone number has already been used</div>	
                                    }
                                </Col>
                            </Row>
                            <br />
                            <br />
                                <I18n>address</I18n>
                            <br />
                            <Row>
                                <Col span={{sm: 18}}>
                                    <FormEntry>
                                        <InputDark required={true} name='address' id='address' question={I18n.t('address')} type='text' initialValue={this.account.address} />
                                    </FormEntry>
                                </Col>
                                <Col span={{sm: 6}}>
                                    <FormEntry>
                                        <InputDark name='unit' id='unit' question={I18n.t('unit')} type='text' initialValue={this.account.unit} />
                                    </FormEntry>
                                </Col>
                            </Row>
                            <br />
                            <Row>
                                <Col span={{sm: 24}}>
                                    <FormEntry>
                                        <InputDark required={true} name='city' id='city' question={I18n.t('city')} type='text' initialValue={this.account.city} />
                                    </FormEntry>
                                </Col>
                            </Row>
                            <br />
                            <Row>
                                <Col span={{sm: 12}}>
                                    <FormEntry>
                                        <SelectDark 
                                            required={true} 
                                            name='state' 
                                            id='state' 
                                            data={this.states} 
                                            placeholder={
                                                I18n.t(
                                                    this.organization.country === "US" ?
                                                    'state' 
                                                    : 'province'
                                                )} 
                                            initialValue={this.stateValue} 
                                            autocomplete="disabled"
                                            dropDownLength={5}
                                        />
                                    </FormEntry>
                                </Col>
                                <Col span={{sm: 12}}>
                                    <FormEntry>
                                        <InputDark required={true} name='zip' id='zip' question={
                                            this.organization.country === "US" ?
                                            I18n.t('zipCode') 
                                            : I18n.t('postalCode')
                                            } type='text' initialValue={this.account.zip} />
                                    </FormEntry>
                                </Col>
                            </Row>
                            <br />
                            <Row>
                                {this.customFields.map((customField)=>{
                                    if(!this.newPatient && !this.state.editing && !this.account[customField.key] && !customField.required){
                                        return
                                    }
                                    return (
                                        <Col span={{sm: 24, md: 12, lg: 8}}>
                                            {!this.newPatient && !this.state.editing?
                                                <div>
                                                    <label>
                                                        {customField.label}
                                                    </label>
                                                    &nbsp;{!_.isNil(this.account[customField.key]) ? `${this.account[customField.key]}` : 'none'}
                                                </div>
                                            :
                                                <FormEntry >
                                                    {customField.type == 'Boolean' &&
                                                        <Toggle class={style.customToggle} selected={this.state.customBooleans[customField.key]} onSelect={this.handleToggleCustomField.bind(this, customField)}>
                                                            {customField.label}
                                                        </Toggle>
                                                    }
                                                    {customField.dropdownOptions && customField.dropdownOptions.length > 0 &&
                                                        <SelectDark 
                                                            required={customField.required} 
                                                            name={customField.key}
                                                            id={customField.key} 
                                                            data={customField.dropdownOptions} 
                                                            placeholder={customField.label} 
                                                            initialValue={this.account[customField.key]} 
                                                        />
                                                    }	
                                                    {(!customField.dropdownOptions || customField.dropdownOptions.length == 0) && customField.type != 'Boolean' &&
                                                        <InputDark
                                                            required={customField.required}
                                                            type={mapInputType[customField.type]}
                                                            step={customField.type == 'Float' && .01}
                                                            name={customField.key}
                                                            question={customField.label}
                                                            initialValue={this.account[customField.key]}
                                                            onChange={this.handleColorChange} 
                                                        />
                                                    }
                                                </FormEntry>
                                            }
                                        </Col>
                                    )
                                })}
                            </Row>
                            <br />
                            {!this.account.id ?
                                <div>
                                    <br />
                                    <br />
                                    Password
                                    <br />
                                    <Row>
                                        <Col span={{sm: 12}}>
                                            <FormEntry>
                                                <InputDark name="password" onChange={this.handlePassword} required={true} question='Password' type='password' />
                                            </FormEntry>
                                        </Col>
                                        <Col span={{sm: 12}}>
                                            <FormEntry>
                                                <InputDark name="passwordConfirmation" onChange={this.handlePasswordConfirmation} required={true} question='Password Confirmation' type='password' />
                                            </FormEntry>
                                        </Col>
                                    </Row>
                                    <br />
                                    <div className='text-left'>
                                    <div>
                                        {this.state.hasNumber ?
                                            <i {...checked} /> :
                                            <i  {...open}  />
                                        } Has at least 1 number
                                    </div>
                                    <div>
                                        {this.state.hasUpperCase ?
                                            <i {...checked} /> :
                                            <i {...open} />
                                        } Has at least 1 uppercase letter
                                    </div>
                                    <div>
                                        {this.state.hasLowerCase ?
                                            <i {...checked} /> :
                                            <i {...open} />
                                        } Has at least 1 lowercase letter
                                    </div>
                                    <div>
                                        {this.state.hasEightCharacters ?
                                            <i {...checked} /> :
                                            <i {...open} />
                                        } Has at least 8 characters
                                    </div>
                                    <div>
                                        {this.state.passwordConfirmationMatches ?
                                            <i {...checked} /> :
                                            <i {...open} />
                                        } Password Confirmation Matches
                                    </div>
                                </div>

                                {this.state.passwordError &&
                                    <div class={style.passwordErrorMessage}>{this.state.passwordError}</div>	
                                }
                                </div>
                            : '' }
                        </Fragment>
                    }
                    {!this.organizationAccess && !this.componentIsLoading() &&
                        <Toggle class={style.grantToggle} selected={this.state.accessToggled} onSelect={this.handleToggleAccess}>
                            <I18n>iAgreeToGrant</I18n> <strong>{this.props.organization.name}</strong> <I18n>accessToInformation</I18n>
                        </Toggle>
                    }
                    {this.state.grantError &&
                        <div class={style.passwordErrorMessage}>{this.state.grantError}</div>	
                    }
                    {(this.state.editing || !this.organizationAccess) && 
                        <Button spinner={this.componentIsLoading()}>{this.session.accessToken?(
                            <I18n>update</I18n>
                        ):(
                            <I18n>next</I18n>
                        )}</Button>
                    }
                </Form>
            </Container>
        );
    }
}



// WEBPACK FOOTER //
// ./components/partials/ContactInformation/index.js